<template>
  <v-dialog :model-value="isDialogActived" max-width="1120px" persistent scrollable>
    <v-card class="income-dialog">
      <v-card-title class="dialog-title">
        <span>{{ getDialogTitle() }}</span>
        <v-spacer></v-spacer>
        <v-btn v-if="canOpenAnalysis" color="primary" variant="tonal" :disabled="saving" @click="displayAnalysis">
          <v-icon start>assessment</v-icon>
          Analisis
        </v-btn>
      </v-card-title>
      <div class="d-flex flex-wrap ga-2 px-6 pb-3">
        <quick-create-catalog kind="company" label="Agregar empresa" :active="isDialogActived" :disabled="saving" />
        <quick-create-catalog kind="location" label="Agregar lugar" location-type="PROCEDENCIA" :active="isDialogActived" :disabled="saving"
          @saved="editedItem.origin = $event" />
      </div>

      <v-card-text>
        <v-alert v-if="saveError" type="error" variant="tonal" class="mb-4">{{ saveError }}</v-alert>
        <v-alert type="info" variant="tonal" density="comfortable" class="mb-4">
          Debe cargar el analisis del ingreso. Si no lo hace ahora, puede completarlo luego desde la tabla de entradas.
        </v-alert>

        <v-form ref="form" v-model="valid" validate-on="lazy" :disabled="saving">
          <section class="form-section">
            <h2>Datos de entrada</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Nro. de Entrada"
                  v-model="editedItem.incomeNo"
                  type="number"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Fecha de Descarga"
                  v-model="editedItem.downloadDate"
                  type="date"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Cosecha"
                  v-model="commodity.harvesting"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Carta de porte</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Carta de Porte Nro."
                  v-model="editedItem.waybill"
                  :rules="[rules.lenght12, rules.requiredFieldRule]"
                  maxlength="12"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Certificado de Deposito"
                  v-model="editedItem.depositCertificate"
                  type="number"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="C.T.G. Nro."
                  v-model="editedItem.ctg"
                  type="number"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  label="Titular de Carta de Porte"
                  v-model="editedItem.waybillOwner"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  label="Remitente Comercial"
                  v-model="editedItem.commercialSender"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Mercaderia</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-select
                  label="Origen"
                  v-model="editedItem.origin"
                  item-title="name"
                  return-object
                  :items="originLocations"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  label="Destinatario"
                  v-model="editedItem.receiver"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <quality-type-selector v-model="commodity.qualityType"></quality-type-selector>
              </v-col>
              <v-col cols="12" md="4">
                <grain-type-selector v-model="commodity.grainType"></grain-type-selector>
              </v-col>
              <v-col cols="12" md="4">
                <packaging-type-selector v-model="commodity.packagingType"></packaging-type-selector>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Cantidad de Bultos"
                  v-model="commodity.bagQuantity"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Bruto"
                  suffix="Kg."
                  v-model="editedItem.grossWeight"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Tara"
                  suffix="Kg."
                  v-model="editedItem.truckWeight"
                  type="number"
                  min="0"
                  :rules="[rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Neto"
                  suffix="Kg."
                  :model-value="netWeight"
                  readonly
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Ubicacion en Planta"
                  v-model="commodity.locationInPlant"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Transporte</h2>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  label="Transportista"
                  v-model="editedItem.transporter"
                  item-title="name"
                  return-object
                  :items="getBaseCompanies"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Chofer"
                  v-model="editedItem.driverName"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Patente de Camion"
                  v-model="editedItem.truckPatent"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Patente de Acoplado"
                  v-model="editedItem.trailerPatent"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <v-textarea
              label="Observaciones"
              v-model="editedItem.obs"
              auto-grow
              rows="3"
              v-bind="fieldProps"
            />
          </section>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" min-height="48" :disabled="saving" @click="close">Cancelar</v-btn>
        <v-btn v-if="canSave" color="primary" min-height="48" :loading="saving" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import PackagingTypeSelectorVue from '../Common/PackagingTypeSelector'
import GrainTypeSelectorVue from '../Common/GrainTypeSelector'
import QualityTypeSelectorVue from '../Common/QualityTypeSelector'
import CommodityDto from '../../models/Commodity'
import IncomeDto from '../../models/Income'
import { LOCATION_TYPES, locationsForType } from '@/services/location/LocationTypeUtils'
import QuickCreateCatalog from '../Common/QuickCreateCatalog.vue'

export default {
  name: 'AddEditIncomeForm',
  components: {
    QuickCreateCatalog,
    'quality-type-selector': QualityTypeSelectorVue,
    'packaging-type-selector': PackagingTypeSelectorVue,
    'grain-type-selector': GrainTypeSelectorVue
  },

  data: () => ({
    valid: true,
    saving: false,
    saveError: '',
    fieldProps: {
      variant: 'outlined',
      density: 'comfortable'
    },
    rules: {
      requiredFieldRule: v => ((v !== null) && (typeof v !== 'undefined') && (v !== '')) || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0',
      lenght12: v => ((v) && (String(v).length === 12)) || 'El numero de Carta de Porte debe poseer 12 digitos.'
    },
    editedItem: Object.assign({}, IncomeDto),
    commodity: Object.assign({}, CommodityDto)
  }),

  computed: {
    ...mapGetters('incomeModule', ['isDialogActived']),
    ...mapGetters('locationModule', ['getBaseLocations']),
    ...mapGetters('companyModule', ['getBaseCompanies']),
    ...mapGetters('typesModule', ['getPackagingTypes', 'getGrainTypes', 'getQualityTypes']),
    ...mapGetters('authModule', ['hasPermission']),
    canOpenAnalysis () {
      const analysis = this.$store.getters['analysisModule/getAnalysis']
      return this.hasPermission(analysis?.id > 0 ? 'plant.analyses.update' : 'plant.analyses.create') || this.hasPermission('plant.analyses.read')
    },
    canSave () { return this.hasPermission(this.editedItem.id > 0 ? 'plant.incomes.update' : 'plant.incomes.create') },
    originLocations () {
      return locationsForType(this.getBaseLocations, LOCATION_TYPES.ORIGIN, this.editedItem.origin?.id)
    },
    netWeight () {
      return Number(this.editedItem.grossWeight || 0) - Number(this.editedItem.truckWeight || 0)
    }
  },
  created () {
    this.$store.dispatch('locationModule/getBaseLocations')
    this.$store.dispatch('companyModule/getBaseCompanies')
    this.$store.dispatch('typesModule/getPackagingTypes')
    this.$store.dispatch('typesModule/getGrainTypes')
  },

  watch: {
    'isDialogActived': function (val) {
      if (val) {
        this.editedItem = Object.assign({}, this.$store.getters['incomeModule/getSelectedItem'])
        this.saveError = ''
        if (!(this.editedItem.id > 0)) this.editedItem.clientRequestId = crypto.randomUUID()
        this.$store.dispatch('analysisModule/setAnalysisData', this.editedItem.analysis || null)
        if (this.editedItem.id > 0) {
          this.commodity = Object.assign({}, this.editedItem.commodity)
        } else {
          this.commodity = Object.assign({}, this.$store.getters['commodityModule/getDefaultItem'])
        }
      }
    }
  },

  methods: {
    async displayAnalysis () {
      if (!this.canOpenAnalysis || this.saving) return
      this.$store.dispatch('analysisModule/setDialogActived', true)
    },

    getDialogTitle () {
      let dialogTitle
      if (this.editedItem.id > 0) {
        dialogTitle = `Editando Entrada: ${this.editedItem.incomeNo}`
      } else {
        dialogTitle = 'Agregar Entrada'
      }
      return dialogTitle
    },

    close () {
      this.$store.commit('analysisModule/setAnalysisDataAsDefaultItem')
      this.editedItem = Object.assign({}, this.$store.getters['incomeModule/getDefaultItem'])
      this.commodity = Object.assign({}, this.$store.getters['commodityModule/getDefaultItem'])
      this.valid = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.$store.dispatch('incomeModule/setDialogActived', false)
    },

    async save () {
      if (!this.canSave || this.saving) return
      this.saving = true
      this.saveError = ''
      try {
        const validation = await this.$refs.form.validate()
        if (!validation.valid) return
        this.editedItem.analysis = this.$store.getters['analysisModule/getAnalysis']
        this.setCommodity()
        const saved = await this.$store.dispatch('incomeModule/saveIncome', this.editedItem)
        this.editedItem.id = saved.id
        this.$store.commit('analysisModule/setAnalysisDataAsDefaultItem')
        this.close()
      } catch (e) {
        this.saveError = e.response?.data?.message || 'No se pudo confirmar el guardado. Revise el listado antes de reintentar.'
      } finally {
        this.saving = false
      }
    },

    setCommodity () {
      this.commodity.amount = this.netWeight
      this.commodity.obs = this.editedItem.obs
      this.commodity.owner = this.editedItem.waybillOwner.id
      if (this.editedItem.analysis) {
        this.commodity.gramaje = this.editedItem.analysis.gramaje
      }
      this.editedItem.commodities = [this.commodity]
    }
  }
}
</script>
<style scoped>
.income-dialog {
  max-height: 90vh;
}

.dialog-title {
  align-items: center;
  display: flex;
  gap: 12px;
  padding-bottom: 10px;
}

.form-section {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  margin-bottom: 18px;
  padding-bottom: 8px;
}

.form-section:last-child {
  border-bottom: 0;
  margin-bottom: 0;
}

.form-section h2 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 12px;
}
</style>
